import { render } from "./adminsublist2.vue?vue&type=template&id=68064b68&scoped=true&ts=true"
import script from "./adminsublist2.vue?vue&type=script&lang=ts"
export * from "./adminsublist2.vue?vue&type=script&lang=ts"

import "./adminsublist2.vue?vue&type=style&index=0&id=68064b68&lang=scss&scoped=true"
import "./adminsublist2.vue?vue&type=style&index=1&id=68064b68&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68064b68"]])

export default __exports__